//import React from "react";
//import "./DegisimIadeProseduru.css";
//import bgSvg from "../assets/bg.svg";
//import Navbar from "../components/Navbar";

//function Kvkk() {
//    return (
//        <div className="Kvkk" style={{ backgroundImage: `url(${bgSvg})` }}>
//            <Navbar />
//            <div className="degisim-card">
//                <div className="degisim-content">
//                    <h1 className="degisim-title">
//                        SPORTIVE DEĞİŞİM VE İADE KOŞULLARI
//                    </h1>

//                    <h1 className="degisim-title">
//                        <span>SPORTIVE RETURN & EXCHANGE POLICY</span>
//                    </h1>

//                    <ul>
//                        <li>
//                            Mağazalarımızdan satın almış olduğunuz ürünleri, fiş veya slip ibrazı
//                            ile 14 gün içerisinde iade edebilir, 30 gün içerisinde ise değiştirebilirsiniz.
//                            <br />
//                            <span className="green">
//                                Products can be returned within 14 days or exchanged within 30 days, provided that the receipt or sales slip is presented.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Ürünler kullanılmamış, yıkanmamış, giyilmemiş, tadilat görmemiş ve hasar almamış olmalı, orijinal niteliğini kaybetmemiş olmalıdır. İade edilmek istenen ürün, satın alındığı andaki gibi kusursuz, eksiksiz ve orijinal kutusunda olmalıdır. Kutusu, ambalajı ve varsa standart aksesuarlarıyla birlikte eksiksiz ve hasarsız olarak teslim edilmeyen ürünlerin iadesi mümkün değildir.
//                            <br />
//                            <span className="green">
//                                The products must be unused, unwashed, unworn, unaltered, and undamaged, and  must retain their original condition. The product to be returned must be flawless, complete, and in its original box, just it was when purchased. Products that are not returned with their box, packaging, and standard accessories,
//                                if any, in complete and undamaged condition, cannot be refunded.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Kullanılmış tüm ürünler, iade süresi içinde olsa dahi, satılabilirlik özelliklerini yitirdikleri için iade alınmaz.
//                            <br />
//                            <span className="green">
//                                None of the used products cannot be returned, even if they are within the return period, due to loss of resale condition/value.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Aksesuar, iç giyim ve mayo/bikini gibi hijyen ürünlerinde iade veya değişim yapılmaz.
//                            <br />
//                            <span className="green">
//                                Accessories, underwear, and swimwear (bikini/swimsuit) cannot be returned or exchanged due to hygiene reasons.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Özel sipariş ve kişiselleştirilmiş ürünlerin iade ve değişimi mümkün değildir.
//                            <br />
//                            <span className="green">
//                                Special order and personalized products cannot be returned or exchanged.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Hediye kartı ya da hediye fişiyle yapılan alışverişlerde yalnızca değişim yapılabilir; para iadesi yapılamaz.
//                            <br />
//                            <span className="green">
//                                Purchases made with gift cards or gift receipts are eligible for exchange only; refunds are not available.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Franchise mağazalarımızdan satın alınan ürünlerin iade ve değişimi, yalnızca ürünün satın alındığı franchise mağazasında yapılabilir.
//                            <br />
//                            <span className="green">
//                                Returns and exchanges for items purchased from our franchise stores must be processed at the same franchise store where the purchase was made.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Franchise Mağazalarımız <span>/ Our Franchise Stores:</span>
//                            <br />
//                            <span className="green">
//                                Amasya, Alanya Akdeniz Park AVM, Alanyum AVM, Konya
//                            </span>
//                        </li>

//                    </ul>


//                </div>
//            </div>
//        </div>
//    );
//}

//export default Kvkk;
import React from "react";
import Navbar from "../components/Navbar";
import "../App.css";
import bg from "../assets/bg.svg";

export default function Kvkk() {
    return (
        <div
            className="kvkk-page"
            style={{
                minHeight: "100vh",
                backgroundImage: `url(${bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Navbar />

            {/* ✅ İçeriği tam ortalamak için */}
            <div
                className="kvkk-container"
                style={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center", // dikey ortalama
                    alignItems: "center", // yatay ortalama
                    padding: "30px 0",
                }}
            >
                <div
                    className="kvkk-card"
                    style={{
                        width: "90%",
                        maxWidth: "800px",
                        backgroundColor: "white",
                        borderRadius: "20px",
                        border: "8px solid white",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                        overflowY: "auto",
                    }}
                >
                    <div
                        className="kvkk-content"
                        style={{
                            backgroundColor: "#1b2833",
                            color: "#fff",
                            padding: "30px",
                            borderRadius: "12px",
                            lineHeight: "1.6",
                        }}
                    >
                        <h2
                            style={{
                                textAlign: "center",
                                color: "#fff",
                                fontWeight: "800",
                                fontSize: "22px",
                                marginBottom: "10px",
                            }}
                        >
                            KVKK
                        </h2>

                        <h3
                            style={{
                                textAlign: "center",
                                color: "#CDE200",
                                fontWeight: "700",
                                fontSize: "18px",
                                marginBottom: "25px",
                            }}
                        >
                            
                        </h3>

                        <p style={{ marginBottom: "15px" }}>
                            Biz, Sportive Spor Malzemeleri Ticaret Anonim Şirketi olarak, kişisel verilerinizi işlediğimiz bazı durumlara ilişkin rızanızı alabilmek amacıyla bu Açık Rıza Metni’ni hazırladık.
                        </p>

                        {/*<p style={{ color: "#CDE200", fontStyle: "italic" }}>*/}
                        {/*    In accordance with the Personal Data Protection Law No. 6698, we*/}
                        {/*    ensure that your personal data is processed and stored safely.*/}
                        {/*</p>*/}

                        <p>
                            Yukarıda yer alan Aydınlatma Metni kişisel verilerinizi işlediğimiz süreçlere dair bilgilendirilmeniz içindir. Aşağıda vereceğiniz açık rıza ise sadece aşağıda yer alan ve açık rızanızı gerektiren faaliyetlerle ilgili olup Aydınlatma Metni’nin tamamını kapsamaz.
                        </p>
                        <p>
                            Bu metin, “6698 Sayılı Kişisel Verilerin Korunması Kanunu (“Kvkk”) Usul ve Esasları Uyarınca Kişisel Verilerinizin Korunması Hakkında Mağaza Müşterisi Aydınlatma Metni” (“Aydınlatma Metni”) çerçevesinde hazırlanmıştır. Bu sebeple, Aydınlatma Metni’ni okumadan bu metni imzalamamanız konusunda sizi uyarmak isteriz.
                        </p>
                        <p>
                            Mağazada bana sunulan Aydınlatma Metni’ ni okudum ve anladım. Aralarında adım, soyadım, cep telefonu numaram, elektronik posta adresim, cinsiyetim, doğum tarihim ve yaşadığım il, ilçe bilgilerinin yer aldığı bir kısım kişisel verimi Sportive mağazalarının sahibi Sportive Spor Malzemeleri Ticaret A.Ş’ye (“Sportive”), sadakat kartı çıkarılması, üyelik işlemlerim için kendi rızam ile vermiş bulunmaktayım.
                        </p>
                        <p>
                            Mevcut veya ileride güncelleyeceğim kişisel verilerimin; Sportive nezdindeki üyeliklerim ve alışverişlerime göre bana özel olanak ve teklifler sunulması, genel veya bana özel kişiselleştirilmiş kampanyalar, avantajlar, promosyonlar, reklamların oluşturulması, kampanya, yarışma, çekiliş ve diğer etkinliklerin düzenlenmesi, segmentasyon, profilleme, raporlama, pazarlama ve analiz çalışmalarının yapılması, yürütülmesi ile müşteri deneyimini iyileştirmeye yönelik çalışmaların yapılması amacıyla işlenmesine ,
                        </p>
                        <p>
                            6563 s. Elektronik Ticareti Düzenleme Kanunu ve 6698 s. Kişisel Verilerin Korunması Kanunu uyarınca Sportive tarafından işlenmesine, Sportive ve [iş/çözüm] ortaklarının tarafıma yapacağı her türlü bilgilendirme ve ticari içerikli indirim, kampanya, reklam, promosyon, mağaza kartı, çeşitli kampanyalar ile ilgili her türlü ticari elektronik iletiyi göndermesine ve bu bilgilerin Sportive ve hizmet sağlayıcılarıyla iş ortakları tarafından işlenmesine ve aktarılmasına, bu çerçevede kişisel verilerimin yukarıda belirtildiği şekilde işlenmesine ve aktarılmasına rıza veriyorum.
                        </p>

                        <p>
                            6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında SPORTİVE SPOR MALZEMELERİ TİC.A.Ş(“SPORTİVE”) mağazalarından, www.sportive.com.tr adresinden, her zaman erişebileceğim aydınlatma metninde detaylı olarak açıklandığı şekilde SPORTİVE tarafından yürütülen genel veya özel kişiselleştirilmiş kampanyalar, avantajlar, ürün ve hizmet tanıtımları, anket çalışmaları, müşteri memnuniyeti uygulamalarının sunumu, promosyonlar, reklamlar, bilgilendirmeler, pazarlama faaliyetleri kapsamında seçeceğim iletişim kanalları üzerinden tarafıma ticari iletişim faaliyetlerinde bulunulmasına, her türlü ticari elektronik ileti gönderilmesine, kampanya, yarışma, çekiliş, davet ve diğer etkinliklere ilişkin davetlerin iletilmesine ve bu amaçla kişisel verilerimin işlenmesine , bu kapsamda ticari ileti gönderimi sağlanması için SPORTİVE 'in hizmet aldığı üçüncü kişilerle paylaşılmasını hizmet sağlayıcılarına ve alt yapı sağlayıcılarına kişisel verilerimin aktarılmasına onay/izin veriyorum.
                        </p>


                    </div>
                </div>
            </div>
        </div>
    );
}

